export default "__VITE_ASSET__CiYDobyY__"